import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png";

const NavbarPixu: React.FC = () => {
  const navigate = useNavigate();
  return (
    <nav className="flex justify-between items-center py-4 px-32">
      <div className="flex items-center space-x-2">
        <img src={Logo} className="h-14" />
        <span className="text-[40px] font-bold text-gray-900">PIXU</span>
      </div>
      <div className="flex space-x-6 text-gray-900 gap-x-10 font-semibold">
        <a href="#" className="text-blue-600 ">
          Home
        </a>
        <a href="#">Quienes somos</a>
        <a href="#">Servicios</a>
        <a href="#">Precio</a>
        <a href="#">Ayuda</a>
      </div>
      <button
        onClick={() => navigate("/login")}
        className="px-8 py-2 bg-bgSecundary text-white rounded-md font-semibold"
      >
        INGRESA
      </button>
    </nav>
  );
};

export default NavbarPixu;
